<template>
	<c-modal @close="close" :title="'Start met scannen'">

		<c-form ref="form" @valid="submit" class="margin-t-40">

			<h6 class="margin-v-32">{{product.product ? product.product.name : product.name}}</h6>

			<div class="font-heading margin-b-16" @get-data="getData">
				<span class="fw-bold color-gray-600 margin-r-32">Aantal gescand:</span>
				<span class="fw-bold" v-if="product.items && !product.arrived">{{product.items.length}}</span>

				<span class="fw-bold" v-else-if="product.arrived && !product.items">{{product.arrived}}</span>
				<span class="fw-bold" v-else-if="product.items && product.arrived">{{product.items.length + product.arrived}}</span>

				<span class="fw-bold" v-else>0</span>
				<span class="color-gray-600"> / {{product.expected ? product.expected : "1"}}</span>
			</div>

			<c-input
				type="text"
				name="code"
				:label="'Serienummer'"
				:horizontal="true"/>

			<p class="color-alert" v-if="duplicate_error">Serienummer is al gescand.</p>
			<p class="color-alert" v-if="wrongnumber">Serienummer komt niet overeen</p>

			<div class="c-item-field font-heading margin-b-24">

				<div class="c-item-field__empty" v-if="!scanStarted">
					<h6 class="no-margin">Start met scannen</h6>
				</div>

				<div v-else>
					<div class="c-item-field__item">
						<span class="fs-tiny">Serienummer</span>
						<span class="fs-tiny">Omschrijving</span>
					</div>

					<div v-for="(item, index) in copyProducts.copyItems" :key="index" :class="item.style">
						<span class="fs-xsmall">{{item.serialNumber}}</span>
						<span class="fs-xsmall">{{product.product ? product.product.name : product.name}}</span>
						<span class="fs-xsmall delete-item"><div class="icon-close" @click="remove(index)"></div></span>
					</div>
				</div>
			</div>

			<div class="row align-middle">
				<div class="columns">
					<a href="#" class="float-right" @click="openModalScanBulk()">+ Bulk toevoegen</a>
				</div>
			</div>

			<div class="row collapse align-right margin-t-32">
				<div class="columns">
					<a href="#" @click.prevent="resetScan">Reset scannen</a>
				</div>
				<div class="columns shrink">
					<c-button 
						class="c-btn--expanded" 
						type="submit" 
						:disabled="!product.items || product.items.length === 0">
							Opslaan
					</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>



<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import CScanBulk from '@app/modals/ScanBulk';

export default {
	mixins: [Form],
	components: {
		CModal, CScanBulk
	},
	props: {
		product: {
			required: true
		}, 
	},
	data() {
		return {
			scanStarted: false,
			duplicate_error: false,
			wrongnumber: false,
			checknumber: '',
			copyProducts: [],
		}
	},
	watch: {
		product: {
			handler() {
				if(this.product.items){
					this.copyProducts.copyItems = this.product.items.map(item => {
						return {
							serialNumber: item.serialNumber,
							style: "c-item-field__item"
						}
					}
				);
				}
				else {
					this.copyProducts.copyItems = [];
				}
				
      		},
		}
	},
	methods: {
		close() {
			this.$emit('close');
			this.$emit('open-modal-add-prenotification');
		},
		resetScan() {
			this.scanStarted = false;
			this.product.items = [];
			this.copyProducts.copyItems = [];
		},
		submit() {
			this.close();
			this.$emit('open-modal-add-prenotification');
		},
		remove(index){
			this.product.items.splice(index, 1)
			this.copyProducts.copyItems.splice(index, 1)
			this.wrongnumber = false;
			this.duplicate_error = false;
		},
		openModalScanBulk() {
            this.$emit('open-modal-scan-bulk');
        },
		addBulk(bulkItems){
			for (const item of bulkItems) {
				this.scanItem(item)
			}
		},
		scanItem(value){
			value = value.trim(); // This line removes spaces from the beginning and end of value			
			const that = this;

			if(!that.product.items){
				let items = [];
				let copyItems = [];

				that.product.items = items;
				this.checknumber = 0;
				that.copyProducts.copyItems = copyItems;
			}

			that.scanStarted = true;

			let allItems = JSON.stringify(that.product.items);
			let newItem = JSON.stringify({serialNumber: value});
			var includes = allItems.indexOf(newItem);

			if(includes != -1){
				that.duplicate_error = true;
				that.wrongnumber = false;
				that.product.items.push({serialNumber: value});
				that.copyProducts.copyItems.push({serialNumber: value, style: "c-item-field__item red"});
			}
			else if(value.length !== this.checknumber && that.product.items.length !== 0){
				that.wrongnumber = true;
				that.duplicate_error = false;
				that.product.items.push({serialNumber: value});
				that.copyProducts.copyItems.push({serialNumber: value, style: "c-item-field__item red"});
			}
			else {
				that.wrongnumber = false;
				that.duplicate_error = false;
				that.product.items.push({serialNumber: value});
				that.copyProducts.copyItems.push({serialNumber: value, style: "c-item-field__item"});
			}


			if(that.product.items.length == 1){
				this.checknumber = value.length;
			}

		}
	},
	mounted () {

		let target = document.querySelector('[name=code]');
		const that = this;

		target.addEventListener('keydown', function (event) {

			if ( event.key && event.key.toLowerCase() === 'enter' ) {
				event.preventDefault();

				if(this.value.length > 0){
					that.scanItem(this.value)
					this.value = "";
				}
			}
		});

		target.focus();

	}
}
</script>
